export type AnnouncementContentSource = {
	videoUrl?: string | null;
	files?: unknown;
};

export function getAnnouncementFilesList(files?: unknown): unknown[] {
	if (files == null) return [];
	return Array.isArray(files) ? files : [files];
}

export function hasAnnouncementVideo(videoUrl?: string | null): boolean {
	return !!videoUrl?.trim();
}

export function hasAnnouncementFiles(files?: unknown): boolean {
	return getAnnouncementFilesList(files).length > 0;
}

export function getAnnouncementContentIndicators(
	announcement: AnnouncementContentSource
): {hasVideo: boolean; hasFiles: boolean} {
	return {
		hasVideo: hasAnnouncementVideo(announcement.videoUrl),
		hasFiles: hasAnnouncementFiles(announcement.files)
	};
}

export function hasAnnouncementContentChips(announcement: AnnouncementContentSource): boolean {
	const {hasVideo, hasFiles} = getAnnouncementContentIndicators(announcement);
	return hasVideo || hasFiles;
}
